import type { CheckItem, DatabaseFile, Section } from '../types';
import { formatPageListsForClipboard, formatSectionListForClipboard } from './formatListClipboard';

export type ShareKind = 'item' | 'section' | 'page';

export type SharePlainPayload = {
  v: 1;
  kind: ShareKind;
  title: string;
  body: string;
};

export function sharePlaintextForItem(item: CheckItem): SharePlainPayload {
  const body = item.text.trim();
  return { v: 1, kind: 'item', title: 'Item', body };
}

export function sharePlaintextForSection(section: Section): SharePlainPayload {
  const body = formatSectionListForClipboard(section, { includeTitle: true });
  return { v: 1, kind: 'section', title: section.title.trim() || 'Section', body };
}

export function sharePlaintextForPage(file: DatabaseFile): SharePlainPayload {
  const body = formatPageListsForClipboard(file.sections, { includeTitles: true });
  return { v: 1, kind: 'page', title: file.name.trim() || 'Page', body };
}

/** Ad-hoc text from Tools → Encrypt link (not persisted). */
export function sharePlaintextForAdHoc(body: string, title = 'Shared note'): SharePlainPayload {
  return { v: 1, kind: 'item', title: title.trim() || 'Shared note', body: body.trim() };
}

export function serializeSharePlain(payload: SharePlainPayload): string {
  return JSON.stringify(payload);
}

export function parseSharePlain(json: string): SharePlainPayload {
  let o: unknown;
  try {
    o = JSON.parse(json);
  } catch {
    throw new Error('Decrypted data is not valid JSON.');
  }
  if (!o || typeof o !== 'object') throw new Error('Invalid share payload.');
  const p = o as Partial<SharePlainPayload>;
  if (p.v !== 1 || (p.kind !== 'item' && p.kind !== 'section' && p.kind !== 'page')) {
    throw new Error('Unsupported share payload version.');
  }
  if (typeof p.title !== 'string' || typeof p.body !== 'string') {
    throw new Error('Invalid share payload fields.');
  }
  return { v: 1, kind: p.kind, title: p.title, body: p.body };
}
